module.exports = __webpack_public_path__ + "img/Flunder_7.0de85032.jpg";